import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'empathy-required-setting',
  templateUrl: 'required-setting.component.html',
  styleUrls: ['./required-setting.component.scss', './_required-settings-theme.component.scss']
})
export class RequiredSettingComponent {
  @Input() activeQuestion: FormGroup;
  @Input() showBorder = true;
}
